import PercentInput, { PercentInputProps } from "@components/form/PercentInput";
import { UIColor } from "@lib/types/generic";
import { useState } from "react";
import { Group, Showcase } from "./StyleGuide";

const PercentInputs = () => {
  const sizes = [
    "extra-small",
    "small",
    "medium",
    "large",
    "extra-large",
  ] as PercentInputProps["size"][];

  const [value, setValue] = useState(0);
  const [color, setColor] = useState<UIColor>("purple");
  const [textColor, setTextColor] = useState<UIColor>("white");
  const [variant, setVariant] = useState<PercentInputProps["variant"]>("contained");
  const [disabled, setDisabled] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [rounded, setRounded] = useState<boolean>(false);

  const props = {
    value,
    onChange: ({ value }: { value: number }) => setValue(value),
    onBlur: ({ value }: { value: number }) => setValue(value),
    color,
    textColor,
    variant,
    disabled,
    isLoading,
    rounded,
  };

  return (
    <Showcase
      title="Percent Inputs"
      className="percent-inputs"
      colors={[
        {
          color: color,
          label: "Color",
          onChange: setColor,
        },
        {
          color: textColor,
          label: "Text Color",
          onChange: setTextColor,
        },
      ]}
      selects={[
        {
          value: variant ?? "contained",
          optionsArray: ["contained", "outlined", "flat", "transparent"],
          label: "Variant",
          onChange: setVariant,
        },
      ]}
      checkboxes={[
        {
          value: disabled,
          label: "Disabled",
          onChange: setDisabled,
        },
        {
          value: isLoading,
          label: "Is loading",
          onChange: setIsLoading,
        },
        {
          value: rounded,
          label: "Rounded",
          onChange: setRounded,
        },
      ]}>
      {sizes.map(size => (
        <Group key={size}>
          <PercentInput size={size} {...props} />
          <PercentInput size={size} {...props} min={-100} max={0} />
        </Group>
      ))}
    </Showcase>
  );
};

export default PercentInputs;
